import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

export interface NavItem {
  active?: boolean;
  title?: string;
  titleIcon?: string;
  displayName?: string;
  route?: string;
  icon?: string;
  children?: NavItem[];
  dataId?: string;
  dataType?: 'division' | 'organization';
}

@Component({
  imports: [CommonModule, MatMenuModule, MatIconModule, TranslatePipe],
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss'],
  standalone: true,
})
export class MenuItemComponent {
  @Input()
  parent: NavItem;

  @Input()
  items: NavItem[];

  @ViewChild('childMenu', { static: true })
  public childMenu: MatMenu;

  @Output()
  navItemClicked: EventEmitter<NavItem> = new EventEmitter<NavItem>();

  constructor(public router: Router) {}

  onNavItemClicked(item: NavItem): boolean {
    this.navItemClicked.next(item);
    return false;
  }
}
